// removed by extract-text-webpack-plugin
module.exports = {"root":"_3ZAhL_sk_5tgF3cWNTOGP6","header":"_3jVSRvNnkAh7qMki7W95hA","simple":"_32g4u1c3HYEM9vNNfMMx3Z","title":"RQatkhlGDfMPm3ILWutbd","isWarning":"_1Fg7SBENbpnT7szWQGaP1v","footer":"JoXC_aydloRn3nN9SeqEP","withoutBottomPadding":"_4GjcRRIErlLTfssN23Fk3","withoutPadding":"_3q4aOZHtMdfoMW8EXNG1AY","body":"NDJfjTZnotQtCDZUlOp05"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 1281
// module chunks = 1